/**
 * Detects if the app is running in widget mode (embedded on third-party site)
 * vs standalone mode (running on *.syndeo.*)
 */

export const isWidgetMode = (): boolean => {
  if (typeof window === 'undefined') return false;

  const hostname = window.location.hostname;

  // If we're on any *.syndeo.* domain (customer subdomains), we're in standalone mode
  // Examples: restaurant.syndeo.rs, salon.syndeo.uk, clinic.syndeo.com
  if (hostname.includes('.syndeo.')) {
    // But exclude system domains like business.syndeo.* and help.syndeo.*
    if (hostname.startsWith('business.syndeo.') || hostname.startsWith('help.syndeo.')) {
      return true; // These are considered widget-like for layout purposes
    }
    return false; // Customer subdomains are standalone
  }

  // If we're on localhost or .local, we're in standalone mode (for development)
  if (hostname === 'localhost' || hostname.includes('.local')) {
    return false;
  }

  // Otherwise, we're embedded as a widget on a third-party site
  return true;
};

export const isStandaloneMode = (): boolean => {
  return !isWidgetMode();
};

export default isWidgetMode;
